import { render, staticRenderFns } from "./SPUEditor.vue?vue&type=template&id=df49900a&scoped=true"
import script from "./SPUEditor.vue?vue&type=script&lang=ts"
export * from "./SPUEditor.vue?vue&type=script&lang=ts"
import style0 from "./SPUEditor.vue?vue&type=style&index=0&id=df49900a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df49900a",
  null
  
)

export default component.exports